<template>
  <div class="tags">
    <template
      v-for="(tag, index) in tags"
    >
      <div 
        :key="index"
        class="multiselect__tag read-only-tag"
        :style="'background:#'+tag.tag.color.color_hex+';'"
      >
        {{tag.tag.name}}
      </div>
    </template>
  </div>
</template>

<script>

export default {
  props: {
    tags: { type: Array },
  },
  data() {
    return {}
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.multiselect__tag {
  flex-wrap: wrap;
  padding: 4px 10px 4px 10px;
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
